import config from "@/config/config";

const getRequestParams = () => {
  // 获取当前页面的 URL
  var currentURL = window.location.href;
  const url = new URL(currentURL);
  return new URLSearchParams(url.search);
  // const keyValue = params.get("key");
  // console.log("params:", keyValue);

  // let url = location.hash; //获取url中"?"符后的字串
  // if (!url) return {};
  // const theRequest = new Object();
  // if (url.indexOf("?") != -1) {
  //   url = url.split("?")[1];
  //   const str = url.substr(0);
  //   const strs = str.split("&");
  //   for (let i = 0; i < strs.length; i++) {
  //     theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
  //   }
  // }
  // return theRequest;
};

const refreshPage = () => {
  window.location.href = config.shareLink;
};

const filterEmoji = (str) => {
  var regStr = /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/gi;
  return str.replace(regStr, "*");
};

export default {
  getRequestParams,
  refreshPage,
  filterEmoji,
};
